import { render, staticRenderFns } from "./PersonNew.vue?vue&type=template&id=4d3b4688"
import script from "./PersonNew.vue?vue&type=script&lang=js"
export * from "./PersonNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports